export default __webpack_public_path__ + "maps-examples-simple-map-view-thumbnail-480-89ac502d13b3322c2cbcaa7f490ca62b.png";